<template>
  <v-card>
    <v-toolbar color="secondary lighten-2" dark>
      <v-toolbar-title>{{ $t('audit_widget_label') }}</v-toolbar-title>

      <v-spacer></v-spacer>

      <v-btn flat icon color="accent" @click="$router.push('/auditmatrix')">
        <v-icon>open_in_new</v-icon>
      </v-btn>
    </v-toolbar>

    <v-card flat>
      <v-card-text v-if="currentAudits">
        <v-list two-line subheader>
          <!--<v-subheader inset>Overdue</v-subheader>-->

          <v-list-tile
            v-for="(item, item_id) in currentAudits"
            :key="item_id"
            avatar
            @click="$router.push('/audit/' + item.id)"
          >
            <!--<v-list-tile-avatar>
                                <v-icon v-if="item.priority" :class="[item.iconClass]">!</v-icon>
                                <v-icon v-else :class="[item.iconClass]"></v-icon>
            </v-list-tile-avatar>-->

            <v-list-tile-content>
              <v-list-tile-title>
                {{ item.name }} /
                <snippet-standard :standard="item.standard" />&nbsp;/
                <snippet-scope :items="item.scope" />
              </v-list-tile-title>
              <v-list-tile-sub-title>
                Lead-Auditor:
                <snippet-user :currentUsers="item.leadauditor"></snippet-user>
              </v-list-tile-sub-title>
              <v-list-tile-sub-title>
                <SnippetDate format="chips" :items="item.auditing_date" />
              </v-list-tile-sub-title>
            </v-list-tile-content>

            <v-list-tile-action>
              <v-chip ripple color="primary" outline>
                <SnippetWorkflow
                  v-if="item.workflow"
                  :status="item.workflow.status"
                  workflow-name="audit"
                />
              </v-chip>
            </v-list-tile-action>
          </v-list-tile>
        </v-list>
      </v-card-text>
      <v-card-text v-else>
        <v-progress-circular indeterminate color="grey" />
      </v-card-text>
    </v-card>
  </v-card>
</template>

<i18n>
    {
        "de": {
            "audit_widget_label" : "Audits",
            "audit_widget_myaudits" : "Zu erledigen",
            "audit_widget_allaudits" : "Verantwortlich",
            "audit_widget_auditdate" : "Audit-Datum: "
        },
        "en": {
            "audit_widget_label" : "Audits",
            "audit_widget_myaudits" : "Todos",
            "audit_widget_allaudits" : "Verantwortlich",
            "audit_widget_auditdate" : "Audit-Date: "
        }
    }
</i18n>

<script>
// Snippets
import SnippetUser from "@/components/snippets/SnippetUser.vue";
import SnippetScope from "@/components/snippets/SnippetScope.vue";
import SnippetStandard from "@/components/snippets/SnippetStandard.vue";
import SnippetDate from "@/components/snippets/SnippetDate.vue";
import SnippetWorkflow from "@/components/snippets/SnippetWorkflow.vue";

import moment from "moment";

import { mapGetters, mapActions } from "vuex";
import { api } from "@/store/modules/audits";

export default {
  data() {
    return {
      boxes: [
        { id: "today", description: "Today" },
        { id: "tomorrow", description: "Tomorrow" },
        { id: "nextweek", description: "Next Week" },
        { id: "nextmonth", description: "Next Month" }
      ],
      workflowoptions: {
        color: "primary"
      },
      unlistener: null
    };
  },
  components: {
    SnippetUser,
    SnippetDate,
    SnippetScope,
    SnippetWorkflow,
    SnippetStandard
  },
  created() {
    this.loadAudits({
      limit: 10,
      user: this.$user.id(),
      status: this.getFinalWorkflowStatusId
    }).then(unlistener => {
      this.unlistener = unlistener;
    });
  },
  beforeDestroy() {
    this.clearAudits(this.unlistener);
  },
  computed: {
    ...mapGetters(api.namespace, [
      api.getters.loadedAudits,
      api.getters.getFinalWorkflowStatusId
    ]),
    currentAudits() {
      return this.loadedAudits;
    },
    filter(items, query /*, sort*/) {
      return items.filter(function(item) {
        let now = moment();
        let today = now.clone().startOf("day");
        let yesterday = now
          .clone()
          .add(-1, "days")
          .startOf("day");
        let lastweek = now
          .clone()
          .add(-7, "days")
          .startOf("day");
        let momentDate = moment(item.auditing_date);

        if (query === "today") {
          if (momentDate.isSame(today, "d")) {
            return item;
          }
        } else if (query === "tomorrow") {
          if (momentDate.isSame(yesterday, "d")) {
            return item;
          }
        } else if (query === "nextweek") {
          if (
            momentDate.isAfter(lastweek, "d") &&
            momentDate.isBefore(yesterday, "d")
          ) {
            return item;
          }
        } else if (query === "nextmonth") {
          if (momentDate.isBefore(lastweek, "d")) {
            return item;
          }
        } else {
          return item;
        }
      });
    }
  },
  methods: {
    ...mapActions(api.namespace, [
      api.actions.loadAudits,
      api.actions.clearAudits
    ])
  }
};
</script>
